import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import AboutSanfer from './components/AboutSanfer'
import Blog from './components/Blog'
import BusinessAreas from './components/BusinessAreas'
import Companies from './components/Companies'
import Foundation from './components/Foundation'
import Hero from './components/Hero'
import Loader from '../../baseComponents/Loader'
import { getHome } from '../../services/home'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import './index.css'

const Home = props => {

  const { lang } = props.settings
    , texts = langTexts[lang]

  const [isFetching, setIsFetching] = useState(true)
    , [data, setData] = useState(null)
    , [activeClass, setActiveClass] = useState('')

  useEffect(() => {
    let timeout = null
    getHome()
      .then(res => {
        setData(res)
        // setIsFetching(false)
        timeout = setTimeout(() => {
          setIsFetching(false)
          setActiveClass('active')
        }, 2000)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  if (isFetching) return <Loader />

  let info = data[lang]

  return <MainLayout id='home' className={`${activeClass} transition`} redLabel={false}>
    <Hero data={info} lang={lang} texts={texts} />
    <AboutSanfer data={info} lang={lang} texts={texts} />
    <Blog data={info} lang={lang} texts={texts} />
    <BusinessAreas data={info} lang={lang} texts={texts} />
    <Foundation data={info} lang={lang} texts={texts} />
    <Companies data={info} lang={lang} texts={texts} />
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Home)